import React, { useState, useEffect } from 'react';
import './Categories.css';
import { FaChevronRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import { collection, onSnapshot, query, orderBy, getDocs, where } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

// Alt bileşen: Her kategori şeridinin kendi slayt mantığı
const CategoryStrip = ({ cat, index, count }) => {
  const [images, setImages] = useState([]);
  const [currentIdx, setCurrentIdx] = useState(0);

  useEffect(() => {
    const fetchCatImages = async () => {
      // Kanka burada orderBy'ı kaldırdım, hata veren kısım burasıydı.
      // Sadece kategoriye göre çekiyoruz.
      const q = query(
        collection(db, "products"),
        where("cat", "==", cat.slug)
      );
      
      const snap = await getDocs(q);
      
      // Ürünleri çektikten sonra JS tarafında tarihe göre diziyoruz (Index istemez)
      const allProducts = snap.docs.map(doc => doc.data());
      const sortedImgs = allProducts
        .sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds) // En yeni en başa
        .slice(0, 5) // İlk 5 tanesini al
        .map(p => p.img);
      
      setImages(sortedImgs.length > 0 ? sortedImgs : [cat.coverImg]);
    };

    fetchCatImages();
  }, [cat]);

  useEffect(() => {
    if (images.length > 1) {
      const interval = setInterval(() => {
        setCurrentIdx((prev) => (prev + 1) % images.length);
      }, 4000 + (index * 500));
      return () => clearInterval(interval);
    }
  }, [images, index]);

  return (
    <div className="category-strip">
      <div className="strip-bg-wrapper">
        {images.map((img, idx) => (
          <div 
            key={idx}
            className={`strip-bg ${idx === currentIdx ? 'active' : ''}`}
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
        <div className="strip-overlay"></div>
      </div>

      <div className="strip-content">
        <div className="strip-left">
          <span className="cat-number">{index + 1 < 10 ? `0${index + 1}` : index + 1}</span>
          <div className="cat-info">
            <h2>{cat.title}</h2>
            <p>{cat.sub || `${cat.title} Koleksiyonu ve Nadir Parçalar`}</p>
          </div>
        </div>

        <div className="strip-right">
          <span className="item-count-badge">
            {count || 0} Ürün
          </span>
          <Link to={`/kategori/${cat.slug}`} className="explore-btn">
            KOLEKSİYONU GÖR <FaChevronRight />
          </Link>
        </div>
      </div>
    </div>
  );
};

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Buradaki tekli orderBy sorun yaratmaz kanka, Composite Index istemez.
    const q = query(collection(db, "categories"), orderBy("createdAt", "asc"));
    
    const unsub = onSnapshot(q, async (snapshot) => {
      const catData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setCategories(catData);
      
      const countsObj = {};
      for (const cat of catData) {
        // Burada da sadece where var, sorun yok.
        const qProd = query(collection(db, "products"), where("cat", "==", cat.slug));
        const prodSnap = await getDocs(qProd);
        countsObj[cat.slug] = prodSnap.size;
      }
      setCounts(countsObj);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) return <div className="categories-page"><Navbar /><div className="loader">Koleksiyonlar Hazırlanıyor...</div></div>;

  return (
    <div className="categories-page">
      <Navbar />
      <div className="categories-container">
        <header className="categories-header">
          <span className="gold-subtitle">Koleksiyon Grupları</span>
          <h1 className="categories-title">Kategoriler</h1>
          <div className="header-line"></div>
        </header>

        <div className="categories-stack">
          {categories.map((cat, index) => (
            <CategoryStrip 
              key={cat.id} 
              cat={cat} 
              index={index} 
              count={counts[cat.slug]} 
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Categories;